import React, { Component } from "react";
import ReactDOM from "react-dom";

class LegacyPackingSlip extends Component {
	
	componentDidMount() {
		window.$(ReactDOM.findDOMNode(this)).modal("show");
		window.$(ReactDOM.findDOMNode(this)).on("hidden.bs.modal", this.props.modalHidden)
		// bootstrap puts a blur on ".modal-open .page-wrapper" and recommends placing modals in a top-level to prevent
		// other CSS from affecting the modal appearance. We can't do this though, because the react root is nested
		// pretty deep in the wrapping DOM, so instead we're programatically dropping the blurry styles
		window.$(".page-wrapper").css({
			"filter": "none",
			"-webkit-filter": "none",
			"-moz-filter": "none",
			"-o-filter": "none",
			"-ms-filter": "none"
		});
	}
	
	render() {
		return (
			<div className="modal fade" id="packingSlipModal" tabIndex="-1" role="dialog">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-header">
							<button type="button" className="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
							<h4 className="modal-title">Order Information</h4>
						</div>
						<div className="modal-body">
						<pre>
							{this.props.order.packingSlip}
						</pre>	
						</div>
						<div className="modal-footer">
							<button type="button" className="btn" data-dismiss="modal">Close</button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
export default LegacyPackingSlip;
